import React from 'react';
import AttachmentUploader from '@src/js/common/ark-extensions/dc-components/attachment-uploader';
import { getAttachmentInfo } from '@src/slide/domain/ui-model/element-modeles/property/attachment/utils/attachment';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { EPermission } from '@src/slide/domain/ui-model/element-modeles/property/attachment/interface';
import { PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import { EShowType } from '@src/slide/domain/ui-model/element-modeles/property/attachment/constants';
import { AttachmentSwitcher } from '@src/slide/application/service/attachment-upload/attachment-switcher';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { hideMqqNavigation, keepSafeAreaInTencentDocApp, showMqqNavigation } from '@src/slide/infrastructure/module/independent/mobile/mqq-navigation';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import Snackbar from '@tencent/dui-mobile/lib/components/Snackbar';

interface PreviewAttachmentToolBarProps {
    selectedModel: IPictureModel | IShapeModel,
    pptEditorState: typeof PPTEditorStateType[keyof typeof PPTEditorStateType];
}
export default function PreviewAttachmentToolBar(props: PreviewAttachmentToolBarProps) {
    const { selectedModel } = props;
    if (!selectedModel) {
        return null;
    }
    const attachment = getAttachmentInfo(selectedModel);
    if (!attachment) {
        return null;
    }

    // 获取权限
    const getPermission = () => {
        const { isOwner } = SlideDataServices.ClientVarsService()?.getClientVars?.() ?? {};
        if (isOwner) {
            return EPermission.OWNER;
        }
        const { pptEditorState } = props;
        if (pptEditorState === PPTEditorStateType.EDITABLE) {
            return EPermission.EDIT;
        }
        if (pptEditorState === PPTEditorStateType.COPYABLE) {
            return EPermission.VIEW;
        }
        return EPermission.VISITOR;
    };

    // 切换样式
    const handleChange = (showType: EShowType) => {
        AttachmentSwitcher.switch(selectedModel, showType);
    };

    // 删除附件
    const handleDelete = () => {
        const { selectionService } = (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
            .viewableServiceLayer;
        selectionService.currentSlide?.deleteElement();
    };

    /**
     * 全屏预览时隐藏和显示移动端导航条，否则会遮住全屏预览的关闭按钮
     * @param isFullScreen
     */
    const handleFullScreenChange = (isFullScreen: boolean) => {
        if (isFullScreen) {
            hideMqqNavigation();
            keepSafeAreaInTencentDocApp();
        } else {
            showMqqNavigation();
            SlideDataServices.SlideTitleManager()?.updateTitle();
        }
    };

    const ToolBar = AttachmentUploader.getInstance().getToolbarComponent();
    return (
        <ToolBar
            attachment={attachment}
            padId={SlideDataServices.DocInfoManager()?.padId ?? ''}
            permission={getPermission()}
            onChangeShowType={handleChange}
            onDelete={handleDelete}
            onFullScreenChange={handleFullScreenChange}
        ></ToolBar>
    );
}
